import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { RoleListPage } from '@/features/roles/pages/RoleListPage';
import { listSearchSchema } from '@/utils/listSearch';

export const Route = createFileRoute('/_auth/users/roles')({
  validateSearch: listSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Roles">
      <Suspense fallback={<PageLoader />}>
        <RoleListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
